import { IconNames } from '@blueprintjs/icons';
import { formatDate, formatNameLastFirst } from '@strata/helper-functions';
import { type ColumnDef, Grid, SecondaryData } from '@strata/react-grid';
import { MessagingBlock } from '@strata/react-messaging-block';
import { IntakeStatusIndicator } from '@strata/react-status-indicators';

import { type IntakeCaseTreatmentSummary } from 'store/api/intakeCaseApi';

const initialSortProperties = [{ id: 'last_updated', desc: true }];

const columns: ColumnDef<IntakeCaseTreatmentSummary>[] = [
    {
        accessorKey: 'prescriber_last_name',
        header: 'Prescriber',
        size: 110,
        cell: ({ row }) => (
            <SecondaryData
                data={formatNameLastFirst(
                    row.original.prescriber_last_name,
                    row.original.prescriber_first_name,
                )}
            />
        ),
    },
    {
        accessorKey: 'create_date',
        header: 'Created Date',
        size: 110,
        cell: ({ getValue }) => <SecondaryData data={formatDate(getValue())} />,
    },
    {
        accessorKey: 'last_updated',
        header: 'Last Updated',
        size: 110,
        cell: ({ getValue }) => <SecondaryData data={formatDate(getValue())} />,
    },
    {
        accessorKey: 'intake_status',
        header: 'Request Status',
        size: 110,
        enableSorting: false,
        cell: ({ getValue }) => <IntakeStatusIndicator status={getValue()} />,
    },
    {
        accessorKey: 'status_detail',
        header: 'Status Details',
        size: 110,
        enableSorting: false,
    },
];

interface IntakeCaseDetailsProps {
    cases?: IntakeCaseTreatmentSummary[];
    isLoading?: boolean;
}

export const IntakeCaseDetails = ({
    cases = undefined,
    isLoading = true,
}: IntakeCaseDetailsProps) => (
    <Grid
        data={cases}
        isLoading={isLoading}
        sortProperties={initialSortProperties}
        noResults={
            <div className="padding__around--large">
                <MessagingBlock
                    size={MessagingBlock.Sizes.SMALL}
                    icon={IconNames.DOCUMENT}
                    primaryText="No prior auth requests available"
                />
            </div>
        }
        columns={columns}
    />
);
